<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    #mainGrid
                    appAutoSize
                    [minHeight]="200"
                    (initialized)="grid.initialize(mainGrid); onGridInitialized()"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Street Area Name'" [binding]="'streetAreaName'" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Sub Contractor'"
                        [binding]="'subContractorVendorId'"
                        [dataMap]="subContractorMap"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Supplier'"
                        [binding]="'supplier'"
                        [dataMap]="supplierMap"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Testing Agency'"
                        [binding]="'testingAgencyVendorId'"
                        [dataMap]="testingAgencyMap"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Required Mix'" [binding]="'requiredMix'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Required Compaction'"
                        [binding]="'requiredCompaction'"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Required Thickness'"
                        [binding]="'requiredThickness'"
                        [width]="140"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Minimum Paving Temp'"
                        [binding]="'minimumPavingTemp'"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Minimum # Test'" [binding]="'minimumNumberTest'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Road Base Depth'" [binding]="'roadBaseDepth'" [width]="140"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Road Base Compaction Required'"
                        [binding]="'roadBaseCompactionRequired'"
                        [width]="200"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Road Base Testing Frequency'"
                        [binding]="'roadBaseTestingFrequency'"
                        [width]="190"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
